<template>
  <div class="mt-2">
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <b-table
          :busy="isLoading"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
          @sort-changed="sortingChanged"
          :tbody-tr-class="rowClass"
          table-class="b-table-sticky-footer"
        >
          <template #table-busy>
            <table-skeleton />
          </template>

          <template #empty>
            <template v-if="newReducedDeferredLisapayBtn">
              <div
                class="d-flex flex-column justify-content-center align-items-center my-3"
                style="max-width: max-content; margin-inline: auto"
              >
                <p class="mb-2">
                  Effettua una ricerca oppure, se non trovi risultati, crea un
                  nuovo Titolo cliccando sul pulsante qui sotto
                </p>
                <b-button
                  class="btn-create"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddNewReducedDeferredLisapay"
                  title="Crea"
                  :disabled="!canVerb(resource, 'store')"
                  style="max-width: max-content"
                >
                  <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  Crea
                </b-button>
              </div>
            </template>
            <template v-else>
              <empty-table
                :isTableInModal="isTableInModal"
                :performedSearch="performedSearch"
                :automaticPerformedSearch="automaticPerformedSearch"
                :filterCount="filterCount"
              />
            </template>
          </template>

          <!-- <template #cell(delay_days)="{ item }" v-if="items.length">
            <span>
              <template v-if="item.insurance_policy_id != null">
                {{ item.delay_days }}
              </template>
              <template v-else> 0 </template>
            </span>
          </template>
          <template #cell(delay_until)="{ item }" v-if="items.length">
            <span>
              <template v-if="item.insurance_policy_id != null">
                {{
                  moment(item.delay_until)
                    .add(item.delay_days, "days")
                    .format("DD/MM/YYYY")
                }}
              </template>
              <template v-else> {{ toLocaleDate(item.delay_until) }} </template>
            </span>
          </template> -->
          <template #cell(description)="{ item }" v-if="items.length">
            <span> {{ item?.payable?.title }}</span>
          </template>
          <template #cell(customer)="{ item }" v-if="items.length">
            <template
              v-if="
                item?.payable?.insurance_ancillaries?.[0]?.insurance_policy
                  ?.registry
              "
            >
              <span
                v-html="
                  toInfoData(
                    item.payable.insurance_ancillaries[0].insurance_policy
                      .registry,
                    'registry',
                  )
                "
              ></span>
            </template>
            <template v-else>-</template>
          </template>
          <!-- <template #cell(primary_group)="{ item }" v-if="items.length">
            <span
              v-if="item.insurance_policy.registry.registry_groups.length"
              >{{
                item.insurance_policy.registry
                  ? item.insurance_policy.registry.registry_groups.length && item.insurance_policy.registry.registry_groups.find(
                    registry_group => registry_group.pivot.primary.value === 'Y'
                  ) ? item.insurance_policy.registry.registry_groups.find(
                    registry_group => registry_group.pivot.primary.value === 'Y'
                  ).code: "-"
                  : "-",
              }}</span
            >
            <span v-else>-</span>
          </template> -->
          <!--          <template-->
          <!--            #cell(insurance_policy_title)="{ item }"-->
          <!--            v-if="items.length"-->
          <!--          >-->
          <!--            <span v-if="item.insurance_policy">-->
          <!--              {{-->
          <!--                item.insurance_policy.attributables?.REPL ||-->
          <!--                item.insurance_policy.attributables?.MODL-->
          <!--                  ? `${item.insurance_policy.attributables?.REPL || ""} ${-->
          <!--                      item.insurance_policy.attributables?.MODL || ""-->
          <!--                    }`.trim()-->
          <!--                  : item.insurance_policy.title-->
          <!--              }}-->
          <!--            </span>-->
          <!--            <span v-else>-</span>-->
          <!--          </template>-->
          <!-- <template #cell(gross)="{ item }" v-if="items.length">
            <span
              v-if="
                item.insurance_policy &&
                item.insurance_policy.sharing_type.value === 1
              "
              title="Coass escluse"
              v-html="item.gross"
            ></span>
            <span
              v-else
              :title="
                item.insurer_participants.length
                  ? 'Coass incluse'
                  : 'Coass assenti'
              "
              v-html="
                toLocaleCurrency(
                  item.gross +
                    item.insurer_participants.reduce(
                      (acc, curr) => (acc = acc + curr.pivot.gross),
                      0,
                    ),
                )
              "
            ></span>
          </template> -->
          <!-- Stato della riga come badge (prima era un bordino colorato
               con la legenda sotto la tabella). -->
          <template #cell(lisapay_status)="{ item }">
            <status-badge kind="lisapay" :status="lisapayStatus(item)" />
          </template>
          <template #cell(insurer)="{ item }">
            {{
              parseInt(item?.payable?.insurer_id)
                ? getInsurers().find((e) => e.value == item.payable.insurer_id)
                    ?.text
                : "-"
            }}
          </template>
          <template #cell(lisabbina)="{ item }" v-if="items.length">
            <b-icon
              v-if="item?.lisabbina === 'Y'"
              icon="check"
              class="check-icon"
            ></b-icon>
          </template>
          <!-- <template
            #cell(insurance_policy_description)="{ item }"
            v-if="items.length"
          >
            <span
              v-if="item.insurance_policy.registry"
              v-html="toInfoData(item.insurance_policy, 'insurance_policy')"
            ></span>
          </template> -->
          <template
            #cell(insurance_policy_number)="{ item }"
            v-if="items.length"
          >
            <template
              v-if="
                item?.payable?.insurance_ancillaries?.[0]?.insurance_policy
                  ?.number
              "
            >
              {{
                item.payable.insurance_ancillaries[0].insurance_policy.number
              }}
            </template>
            <template v-else>-</template>
          </template>
          <template #cell(broker)="{ item }" v-if="items.length">
            <template v-if="item?.payable?.insurance_ancillaries?.[0]?.broker">
              <span
                v-html="
                  toInfoData(
                    item.payable.insurance_ancillaries[0].broker,
                    'broker',
                    0,
                  )
                "
              ></span>
            </template>
            <template v-else>-</template>
          </template>
          <!-- <template #cell(broker_by_id)="{ item }" v-if="items.length">
            <template v-if="item.broker_id && salesmen.length">
              {{ salesmen.find((e) => e.value == item.broker_id)?.text }}
            </template>
            <template v-else>-</template>
          </template> -->
          <template #cell(book_date)="{ item }" v-if="items.length">
            <template v-if="item?.payable?.book_date">
              <span v-html="toLocaleDate(item?.payable.book_date)"></span>
            </template>
            <template v-else>-</template>
          </template>
          <template #cell(cooperators)="{ item }" v-if="items.length">
            <span
              v-html="
                toInfoData(item?.insurance_policy?.collaborator, 'broker', 1)
              "
            ></span>
          </template>
          <!-- <template
            #cell(insurance_policy_insurer)="{ item }"
            v-if="items.length"
          >
            {{
              joinValues([
                item.insurance_policy?.insurer
                  ? item.insurance_policy.insurer.formatted_title
                  : null,
                item.insurance_policy ? item.insurance_policy?.number : null,
              ])
            }}
          </template> -->
          <template
            #cell(insurance_policy_title)="{ item }"
            v-if="items.length"
          >
            {{ getRiskTypeDescription(item.insurance_policy) }}
          </template>
          <template #cell(address_book)="{ item }" v-if="items.length">
            <span
              v-if="item.insurance_policy && item.insurance_policy.registry"
              v-html="
                toInfoData(
                  item.insurance_policy.registry,
                  'address_books',
                  null,
                )
              "
            ></span>
          </template>
          <template
            #cell(note)="item"
            v-if="items.length && this.$route.name !== 'lisapay.index'"
          >
            {{
              item.tasks.length
                ? item.tasks.filter((task) => task.task_type.value === 2).length
                : 0
            }}
          </template>
          <template #cell(note_counter)="row" v-if="items.length">
            <div
              v-if="getVirtualValue('info', row.item).notes"
              role="button"
              class="info-box"
              @click="customOpenNoteModal(row.item, row.index, $event.target)"
              v-b-tooltip="getVirtualValue('info', row.item).notes.content"
            >
              {{ getVirtualValue("info", row.item).notes_counter.content }}
            </div>
          </template>
          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                v-if="actions.includes('infomodal')"
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                title="Modale Dettagli"
              >
                <base-icon name="eye" width="22"></base-icon>
              </b-button>
              <b-button
                v-if="actions.includes('details')"
                size="sm"
                variant="lisaweb"
                @click="row.toggleDetails"
                class="mt-1 mr-1"
                :title="
                  row.detailsShowing ? 'Chiudi dettagli' : 'Apri dettagli'
                "
              >
                <b-icon v-if="row.detailsShowing" icon="chevron-up"></b-icon>
                <b-icon v-else icon="chevron-down"></b-icon>
              </b-button>
              <b-button
                v-if="actions.includes('edit')"
                size="sm"
                variant="lisaweb"
                @click="onEdit(row.item.id)"
                :disabled="isDisabled(row)"
                class="mt-1 mr-1"
                :title="`${
                  isDisabled(row) ? 'Modifica non abilitata' : 'Modifica'
                }`"
              >
                <base-icon name="edit" width="22"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('lisapay_register_to_company')"
                size="sm"
                variant="lisaweb"
                @click="onRegisterToCompany(row.item.id)"
                class="mt-1 mr-1"
                title="Registra in Compagnia"
                :disabled="row.item.registered !== 0"
              >
                <b-icon icon="cash-coin"></b-icon>
              </b-button>

              <b-button
                v-if="actions.includes('destroy')"
                size="sm"
                variant="lisaweb"
                @click="onDestroy(row.item.id)"
                class="mt-1 mr-1"
                title="Elimina"
              >
                <base-icon name="trash" width="22" height="22"></base-icon>
              </b-button>
            </div>
          </template>
          <!-- <template #cell(rowSelector)="{ item }">
            <div class="item-flex-wrapper">
              <div>
                <div
                  v-if="
                    item.book_entries &&
                    !item.book_entries.length &&
                    !isImported(item) &&
                    item.status_ancillary.value === 0
                  "
                  class="action-buttons"
                >
                  <b-button
                    size="sm"
                    variant="primary"
                    @click="onChosen(item)"
                    class="mt-1 mr-1"
                    title="Crea Movimento Contabile"
                    v-if="canVerb('book_entries', 'store')"
                  >
                    <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  </b-button>
                </div>
                <div v-else>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    class="mt-1 mr-1"
                    title="Movimento Contabile già creato"
                    aria-disabled="true"
                    disabled
                  >
                    <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  </b-button>
                </div>
              </div>
              <div
                v-if="$store.state.auth.settings.attributables.LISAPAY === 'Y'"
              >
                <div
                  class="lisapay-button-wrapper"
                  v-if="
                    item.status_ancillary.value === 0 && item.lisapay_paid === 0
                  "
                >
                  <button
                    class="lisapay-button"
                    data-type="simple"
                    @click="payWithLisaPay(item)"
                  >
                    <span class="sr-only">Paga con Lisapay</span>
                  </button>
                </div>
                <div class="lisapay-button-wrapper payed" v-else>Pagato</div>
              </div>
            </div>
          </template>
          <template #cell(rowSelector2)="{ item }">
            <div class="action-buttons">
              <b-button
                size="sm"
                variant="lisaweb"
                @click="onChosen(item)"
                class="mt-1 mr-1"
                title="Seleziona"
              >
                Seleziona
              </b-button>
            </div>
          </template> -->
          <!-- <template #row-details="row">
            <b-card>
              <b-row
                class="mb-2"
                v-for="(value, key) in customized(row.item)"
                :key="key"
              >
                <b-col sm="3" class="text-sm-right"
                  ><b>{{ key | capitalize }}:</b></b-col
                >
                <b-col>{{ value }}</b-col>
              </b-row>
            </b-card>
          </template> -->
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-registry"
                >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-registry"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <table-totals :items="totals" />
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
                <span :data-active="active">{{
                  page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }}</span>
              </template>
              <template v-slot:first-text>
                <span
                  ><base-icon
                    scale="-1"
                    name="chevron_right_last_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:prev-text>
                <span
                  ><base-icon
                    scale="-1"
                    name="chevron_right_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:next-text>
                <span
                  ><base-icon
                    name="chevron_right_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:last-text>
                <span
                  ><base-icon
                    name="chevron_right_last_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>
      <b-modal
        :id="infomodalName"
        @show="onModalShow"
        @hidden="onModalHidden"
        :title="modalTitle"
        size="xl"
        scrollable
        ok-only
        ok-variant="lisaweb"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <button-group-tab></button-group-tab>
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  :dbRowData="dbRowData"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import template from "./template";
import TableTotals from "@/components/TableTotals";
import StatusBadge from "@/components/StatusBadge";
import { lisapayStatus } from "@/utils/statusBadge";
import BaseIcon from "@/components/BaseIcon";
import Appointments from "@/components/insurance-ancillaries/details/Appointments";
import Todo from "@/components/insurance-ancillaries/details/Todo";
import Notes from "@/components/insurance-ancillaries/details/Notes";
import ButtonGroupTab from "@/components/ButtonGroupTab";
import BaseInputPagination from "@/components/form/BaseInputPagination";
import { canVerb } from "@/utils/permissions";
import { mapGetters } from "vuex";
import moment from "moment";

moment.locale("it");
import client from "@/repositories/api";
import { toLocaleCurrency } from "@/utils/strings";
import { toLocaleDate } from "@/utils/dates";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { getVirtualValue } from "@/utils/ancillaries";
import { getRiskTypeDescription } from "../../utils/payments";
import EmptyTable from "@/components/EmptyTable.vue";

const statusCSS = {
  expired: "effective-status-0", // scaduto (ROSA)
  last_day: "effective-status-1", // ultimo giorno (ARANCIONE)
  ending: "effective-status-2", // in scadenza (GIALLO)
  valid: "effective-status-3", // valido (NEUTRO)
};

export default {
  name: "ReducedDeferredLisapayTable",
  extends: template,
  data() {
    return {
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      tabs: [
        { name: "Appointments", text: "Appuntamenti" },
        { name: "Notes", text: "Note" },
        { name: "Todo", text: "Attività" },
      ],
      selected: "Appointments",
      salesmen: [],
      modalResourceId: null,
      tabIndex: 0,
      communication_types: [],
      codeAgency: /(?:www.)?(\w+)(\..*)+/.exec(window.location.hostname)[1],
      dbRowData: null, // used to pass the actual record to tabs
    };
  },
  props: {
    performedSearch: {
      type: Boolean,
      default: false,
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    total_deferred: {
      type: Object,
      default() {
        return {};
      },
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    newReducedDeferredLisapayBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getRiskTypeDescription,
    toLocaleCurrency,
    toLocaleDate,
    canVerb,
    getVirtualValue,
    moment,
    lisapayAddress(item) {
      const c = item.insurance_policy?.registry?.correspondences?.[0];
      return c
        ? [
            c.attributables?.ADDR,
            [c.attributables?.ZIP, c.geo_location?.COUNCIL]
              .filter(Boolean)
              .join(" "),
            c.geo_location?.PRVCODE && `(${c.geo_location.PRVCODE})`,
          ]
            .filter(Boolean)
            .join(", ")
        : "";
    },
    onRegisterToCompany(id) {
      console.log(
        `Clicked on button, with id: ${id}, action: lisapay_register_to_company`,
      );
      const Repo = RepositoryFactory.get("lisapay_proceed");
      Repo.setRegistered(id)
        .then(() => {
          this.$showSnackbar({
            preset: "info",
            text: `Titolo registrato in Compagnia.`,
          });
          this.fetch();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    isImported(item) {
      let isImported = item.insurance_policy?.insurer.importer_id !== null;
      if (isImported && item.insurance_policy?.insurer.import_override === 1) {
        isImported = false;
      }
      return isImported;
    },
    onModalShow() {
      if (this.tabIndex < this.tabs.length)
        this.setTab(this.tabs[this.tabIndex], this.tabIndex);
    },
    onModalHidden() {
      if (this.isTableInModal) {
        this.$emit("reloadTables");
      }
      this.setTab({ name: "General", text: "Generale" }, 0);
    },
    customOpenNoteModal(item, index, target) {
      this.tabIndex = 1; // TabIndex ID delle Note
      this.openModal(item, index, target);
    },
    payWithLisaPay(item) {
      if (!this.isLisapayConfigured) {
        this.$showSnackbar({
          preset: "error",
          text: "Configurazione Lisapay non disponibile.",
        });
        return;
      }
      const pre_collect = `https://${this.lisapayConfig.callback_base_url}/pre-collect/${this.codeAgency}/${item.id}`;
      const post_collect = `https://${this.lisapayConfig.callback_base_url}/post-collect/${this.codeAgency}/${item.id}`;
      let str = "";

      if (item.code.value === "P") {
        str = `Polizza ${item.insurance_policy.insurer.title} n. ${item.insurance_policy.number}`;
      } else if (item.code.value === "Q") {
        str = `Quietanza ${item.insurance_policy.insurer.title} n. ${item.insurance_policy.number}`;
      } else if (item.code.value === "A") {
        str = `Appendice ${item.insurance_policy.insurer.title} n. ${item.insurance_policy.number}`;
      }

      console.log("item_type: ", item.insurance_policy.insurer.title);
      console.log(
        "ramo: ",
        item.insurance_policy.insurance_risk.risk_branch.risk_type.code,
      );
      console.log("amount: ", Number.parseFloat(item.gross).toFixed(2));
      console.log(
        "annual_amount: ",
        Number.parseFloat(item.insurance_policy.annual_gross).toFixed(2),
      );
      console.log("description: ", str);
      console.log("reference: ", item.insurance_policy.registry.title);
      console.log("pre_collect: ", pre_collect);
      console.log("pre_collect: ", pre_collect);

      const url = `https://${this.lisapayConfig.base_url}/api/v1/carts/add-item`;

      // ramo: item.insurance_policy.insurance_risk.risk_branch.risk_type.code

      const branch =
        item.insurance_policy.insurance_risk.risk_branch.risk_type.code;

      const bodyRequest = {
        code: `LW3-${this.codeAgency.toUpperCase()}-${
          item.insurance_policy.insurer.code
        }-${branch}`,
        branch: branch,
        amount: Number.parseFloat(item.gross).toFixed(2),
        annual_amount: item.insurance_policy.annual_gross
          ? Number.parseFloat(item.insurance_policy.annual_gross).toFixed(2)
          : Number.parseFloat(
              item.gross *
                (item?.insurance_policy?.payment_splitting?.value === 0
                  ? 1
                  : 12 / item?.insurance_policy?.payment_splitting?.value),
            ).toFixed(2),
        description: str,
        platform: "Lisaweb 3.0",
        reason: `${item.insurance_policy.insurer.code} ${item.insurance_policy.number}`,
        reference: item.insurance_policy?.registry?.title,
        precall_url: pre_collect,
        callback_url: post_collect,
        callback_method: "POST",
        external_id: `${item.id} - ${this.codeAgency.toLowerCase()}`,
        fiscal_code: item.insurance_policy?.registry?.attributables?.NINO,
        email:
          item.insurance_policy?.registry?.address_books?.[0]?.attributables
            ?.MAIL,
        residence_address: this.lisapayAddress(item),
      };

      let popup;

      client
        .put(url, bodyRequest, {
          headers: {
            lwAgency: this.codeAgency,
            lwRealm: this.lisapayConfig.realm,
            lwToken: this.$store.state.auth.token,
          },
        })

        .then((response) => {
          console.log("response", response);
          // se popup_already_opened è false, chiamare il window.open e la rotta è: /cart/:id che è quello che mi è arrivato

          if (!response.data.popup_already_opened) {
            const windowFeatures = "popup=1,left=10,width=1000,height=1000";

            popup = window.open(
              `https://${this.lisapayConfig.base_url}/cart/${response.data.id}?lwAgency=${this.codeAgency}&lwRealm=${this.lisapayConfig.realm}&lwToken=${this.$store.state.auth.token}`,
              "Lisapay",
              windowFeatures,
            );
          } else {
            if (popup) {
              popup.focus();
            }
          }
        })
        .catch((error) => {
          switch (error.status) {
            case 422: // Unprocessable Content
              this.error_msg =
                "C'è stato un errore, ti preghiamo di ricontrollare i dati inseriti.";
              break;
            default:
              this.error_msg =
                "C'è stato un errore, ti preghiamo di riprovare più tardi. Se il problema persiste, ti invitiamo a contattare l'assistenza.";
          }
        });
    },
    isDisabled(row) {
      return ["A"].includes(row.item.code.value) && row.item.book_entries.length
        ? true
        : false;
    },
    customized(item) {
      console.log("Item: ", item);
      // let c = {};
      // c.cellullare = item.insurance_policy.registry.attributables.CELL;
      // c.telefono = item.insurance_policy.registry.attributables.PHON;
      // c.email = item.insurance_policy.registry.attributables.MAIL;
      // c.fax = item.insurance_policy.registry.attributables.FAX;
      // return c;
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      // In Lisapay lo stato è nella colonna Stato (lisapayStatus).
      if (this.$route.name === "lisapay.index") return;
      return statusCSS[item.expiration];
    },
    lisapayStatus,
    retriveOwner(value) {
      if (!value) return "-";
      return (
        this.getUsers().find((user) => user.value === value)?.username ?? "-"
      );
    },
    ...mapGetters("auth", ["isLogged", "user", "settings"]),
    ...mapGetters("auth", {
      getInsurers: "insurers",
      getUsers: "users",
      getSalesmen: "salesmen",
    }),
  },
  computed: {
    // Totali fuori dalla tabella (TableTotals), nella riga della paginazione.
    totals() {
      if (!(this.items.length)) return [];
      return [["Totale incassato", this.total_deferred]]
        .filter(([, t]) => Object.keys(t).length)
        .map(([label, t]) => ({
          label,
          value: this.toLocaleCurrency(t.total),
          loading: t.isLoading,
        }));
    },
    ...mapGetters("auth", ["lisapayConfig", "isLisapayConfigured"]),
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  components: {
    TableTotals,
    StatusBadge,
    BaseIcon,
    BaseInputPagination,
    Appointments,
    Todo,
    Notes,
    ButtonGroupTab,
    EmptyTable,
  },
  mounted() {
    this.salesmen = this.getSalesmen();
  },
};
</script>
<style lang="scss" scoped>
.check-icon {
  color: green;
}

/** inserisce un gradiente orizzontale nella prima cella della table */
/* ROSA */
:deep(.effective-status-0 td:nth-child(3)) {
  background: inherit !important;
  border-left: 5px solid rgba(255, 0, 0, 0.3) !important;
}

/* ARANCIONE */
:deep(.effective-status-1 td:nth-child(3)) {
  background: inherit !important;
  border-left: 5px solid rgba(253, 173, 0, 0.4) !important;
}

/* GIALLO */
:deep(.effective-status-2 td:nth-child(3)) {
  background: inherit !important;
  border-left: 5px solid rgba(255, 255, 0, 0.3) !important;
}

/* NEUTRO */
:deep(.effective-status-3 td:nth-child(3)) {
  background: inherit !important;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.lisapay-button-wrapper {
  width: 90%;
  max-width: 500px;
  height: 40px;
  margin: auto 10px auto 2px;
}

.lisapay-button {
  display: block;
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 8px;
  border: 0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border-radius: var(--radius-sm);
  min-width: 90px;
}

.lisapay-button[data-type="simple"] {
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 934.7 266.5'%3E%3Cpath d='M337.8,66.2c-2.7-2.7-6.4-4-10.2-3.8c-3.8-0.2-7.5,1.1-10.2,3.8c-2.4,3.2-3.6,7.2-3.3,11.2v110.1 c-0.3,4,0.8,8,3.3,11.2c2.7,2.6,6.4,4,10.2,3.8c3.7,0.2,7.4-1.2,10-3.8c2.6-3.2,3.8-7.2,3.5-11.2v-110 C341.5,73.5,340.3,69.4,337.8,66.2z' fill='%2323469D'/%3E%3Cpath d='M379.5,62.4c-3.8,0-7.4,1.6-10,4.3c-2.8,2.6-4.3,6.2-4.3,10s1.6,7.3,4.3,9.8c2.6,2.8,6.2,4.3,10,4.3h0.6 c7.8-0.2,14.1-6.7,13.9-14.5S387.3,62.2,379.5,62.4z' fill='%2323469D'/%3E%3Cpath d='M494.8,150c-7.9-5.8-17.2-9.6-26.9-11l-8.4-1.8c-5.5-1-10.8-2.6-15.8-4.8c-2.1-1.1-3.5-3.3-3.5-5.7 c-0.1-2.9,1.4-5.6,3.8-7.1c3.5-1.7,7.4-2.5,11.3-2.3c2.4,0,4.9,0.4,7.2,1.1c2.2,0.5,4.3,1.5,6.1,2.8l2.1,1.6 c3.4,3.3,7.9,5.4,12.6,6.2c3,0.1,5.9-1,8.1-3.1c2.2-1.9,3.4-4.8,3.3-7.7c-0.5-6.8-4.9-12.8-11.3-15.4c-8.6-4.5-18.2-6.7-27.9-6.4 c-10.8-0.6-21.5,2.6-30.2,9c-7.4,6-11.5,15-11.2,24.5c-0.4,7.2,2.5,14.1,7.9,18.9c8,5.9,17.3,9.9,27.1,11.5l0,0l10.1,2.8 c0.1,0.2,0.3,0.2,0.5,0.2c10.3,2.6,15.6,5.9,15.6,10.2c0.1,3.1-1.6,5.9-4.3,7.4c-3.8,1.9-8,2.9-12.3,2.6c-3.6,0.1-7.3-0.4-10.7-1.5 c-2.8-1-5.3-2.7-7.4-4.8l-2.6-3c-3-3.9-7.4-6.4-12.2-6.9h-0.7c-6.5,0.2-11.6,5.7-11.4,12.2c0.4,7.6,4.9,14.3,11.8,17.6 c9,5.1,19.3,7.6,29.7,7.2c12.3,0.8,24.6-2.4,35.1-9c8.2-6.1,12.8-15.9,12.2-26.1C503,162,500.1,154.9,494.8,150z' fill='%2323469D'/%3E%3Cpath d='M389.7,102.1c-2.7-2.7-6.4-4-10.2-3.8c-3.8-0.3-7.6,1.1-10.2,3.8c-2.4,3.2-3.6,7.3-3.3,11.3v74.2 c-0.3,4,0.8,8,3.3,11.2c2.7,2.6,6.4,4,10.2,3.8c3.7,0.2,7.4-1.2,10-3.8c2.6-3.2,3.8-7.2,3.5-11.2v-74.2 C393.3,109.4,392.1,105.4,389.7,102.1z' fill='%2323469D'/%3E%3Cpath d='M603.8,185.8v-60.9h0c0.4-8.7-3.9-16.8-11.1-21.2c-9.9-5.4-21.2-7.9-32.4-7.2c-10.1-0.3-20,2.3-28.6,7.6 c-6.7,3.4-11.2,10.1-11.7,17.6c-0.1,3,1,5.8,3.1,7.9c2,2.1,4.8,3.2,7.7,3.1c4.8-0.5,9.1-3,12-6.9l3.1-3.1c1.9-1.8,4.2-3,6.7-3.8 c1.3-0.5,2.7-0.8,4.1-1s2.9-0.3,4.4-0.3c4.3-0.4,8.7,0.5,12.6,2.6c2.7,2,4.1,5.3,3.8,8.7c0,1.7-0.3,3.4-1,4.9c-0.8,1.4-2,2.5-3.5,3 c-4.1,1.1-8.3,1.8-12.6,2.1c-6.9,0.8-11.9,1.6-15.4,2.3c-8.6,1.1-16.6,4.9-23,10.8c-4.8,6.1-7.2,13.7-6.7,21.4 c-0.5,8.5,2.4,16.9,8.1,23.2c6,5.7,14.2,8.7,22.5,8.2c6.6,0.1,13.2-1.4,19.2-4.3c5.4-2.8,10-6.9,13.3-12c-0.4,4.4,0.9,8.7,3.6,12.2 c3,2.8,7.1,4.2,11.2,3.9c3.1,0.2,6.1-0.8,8.5-2.8c2.1-2,3.2-4.7,3.1-7.6l-0.5-4.9C604,188.1,603.9,187,603.8,185.8z M571.8,177.7 c-4.4,4.2-10.3,6.5-16.4,6.2c-3.8,0.2-7.5-1-10.4-3.3c-2.6-2.3-3.9-5.5-3.8-8.9c-0.1-3.1,0.9-6.1,2.8-8.4c2.8-2.5,6.2-4.3,9.9-5.1 c3-0.8,5.9-1.5,8.9-2c5.3-1.1,10.4-2.8,15.3-4.9l-0.1,9.6C578.3,167.1,576.1,173.2,571.8,177.7z' fill='%2323469D'/%3E%3Cpath d='M826.1,185.8v-60.9h0c0.4-8.7-3.9-16.8-11.1-21.2c-9.9-5.4-21.2-7.9-32.4-7.2c-10.1-0.3-20,2.3-28.6,7.6 c-6.7,3.4-11.2,10.1-11.7,17.6c-0.1,3,1,5.8,3.1,7.9c2,2.1,4.8,3.2,7.7,3.1c4.8-0.5,9.1-3,12-6.9l3.1-3.1c1.9-1.8,4.2-3,6.7-3.8 c1.3-0.5,2.7-0.8,4.1-1s2.9-0.3,4.4-0.3c4.3-0.4,8.7,0.5,12.6,2.6c2.7,2,4.1,5.3,3.8,8.7c0,1.7-0.3,3.4-1,4.9c-0.8,1.4-2,2.5-3.5,3 c-4.1,1.1-8.3,1.8-12.6,2.1c-6.9,0.8-11.9,1.6-15.4,2.3c-8.6,1.1-16.6,4.9-23,10.8c-4.8,6.1-7.2,13.7-6.7,21.4 c-0.5,8.5,2.4,16.9,8.1,23.2c6,5.7,14.2,8.7,22.5,8.2c6.6,0.1,13.2-1.4,19.2-4.3c5.4-2.8,10-6.9,13.3-12c-0.4,4.4,0.9,8.7,3.6,12.2 c3,2.8,7.1,4.2,11.2,3.9c3.1,0.2,6.1-0.8,8.5-2.8c2.1-2,3.2-4.7,3.1-7.6l-0.5-4.9C826.3,188.1,826.2,187,826.1,185.8z M794.1,177.7 c-4.4,4.2-10.3,6.5-16.4,6.2c-3.8,0.2-7.5-1-10.4-3.3c-2.6-2.3-3.9-5.5-3.8-8.9c-0.1-3.1,0.9-6.1,2.8-8.4c2.8-2.5,6.2-4.3,9.9-5.1 c3-0.8,5.9-1.5,8.9-2c5.3-1.1,10.4-2.8,15.3-4.9l-0.1,9.6C800.6,167.1,798.4,173.2,794.1,177.7z' fill='%2323469D'/%3E%3Cpath d='M133.2,0C59.7,0,0,59.7,0,133.2s59.7,133.2,133.2,133.2s133.2-59.7,133.2-133.2S206.8,0,133.2,0z M186.1,208.7 C186.1,208.7,186.1,208.7,186.1,208.7L186.1,208.7l-91.9,0c-12.2,0-22.2-9.9-22.2-22.1c0,0,0-0.1,0-0.1V70.2C72,57.9,82,48,94.2,48 c12.2,0,22.2,9.9,22.2,22.1c0,0,0,0.1,0,0.1v94.1h69.7c12.3,0,22.2,9.9,22.2,22.2C208.3,198.7,198.4,208.7,186.1,208.7z' fill='%2323469D'/%3E%3Cpath d='M926.4,99.5c-6-2.5-13-1.2-16.6,4.5c-1.2,2-2.1,3.9-2.6,5.7l-17.3,64.2l-0.1,0.1c-0.1,0-0.2,0-0.3-0.1 c-0.1-0.1-0.1-0.3-0.2-0.5l-17.7-63.9c-0.5-1.9-1-3.2-1.6-4.2c-6.8-11.8-26.7-7.9-26.3,6.7c0,1.4,0.4,3.3,1.2,5.8l3,9l28,79.8 c0.2,0.4,0.2,0.8,0.1,1.2c-0.7,3.1-2,6.2-5,7.6c-1.9,0.9-5,0.8-7.3,0.8c-4.5-0.1-10,1.6-11.9,6.2c-1.9,4.6-1.1,10,2.7,13.4h0 c4.1,3.7,10.1,4.5,15.3,4.4c14.8-0.4,22.3-9,27.6-21.9c1.4-3.6,2.8-7.2,4.1-10.8l29.6-83.9c1.3-3.9,3.1-8,3.4-11.6 C935,106.6,931.2,101.5,926.4,99.5z' fill='%2323469D'/%3E%3Cpath d='M710.9,112.8c-7.1-9.5-18.4-14.9-30.2-14.6c-5.9-0.2-11.7,1.2-16.9,4.1c-5.3,3.3-9.8,7.7-13,13l-0.1-3.2 c0.1-3.3-1-6.6-3.3-9c-2.5-2.3-5.8-3.5-9.2-3.3c-3.7-0.2-7.4,1.2-10,3.8c-2.4,3.2-3.6,7.2-3.3,11.2V225c-0.3,4,0.9,8,3.3,11.3 c5.6,5,14.1,5,19.7,0c2.4-3.2,3.6-7.3,3.3-11.3v-35.1c3.1,5.1,7.5,9.2,12.7,12c5.3,2.6,11.2,4,17.1,3.9c11.8,0.1,23-5.5,29.9-15.1 c8.2-11.4,12.3-25.1,11.7-39.1C723.2,137.7,719.1,124,710.9,112.8z M689.8,174.5c-3.6,5.2-9.6,8.2-15.9,8 c-6.6,0.3-12.9-2.7-16.8-8.1c-7.7-14.1-7.7-31.2,0-45.3c3.9-5.2,10.1-8,16.6-7.7c6.5-0.3,12.7,2.8,16.3,8.1c4.2,7,6.3,15.1,5.7,23.2 C696.1,160.4,694.1,168,689.8,174.5z' fill='%2323469D'/%3E%3C/svg%3E")
    #fff center center no-repeat;
  background-origin: content-box;
}

.payed {
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: #28a745;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: left center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  width: 100%;
  text-indent: 14px;
}

:deep(.item-flex-wrapper) {
  display: flex;
  align-items: center;
  gap: 10px;
}

:deep(table td .btn[disabled]) {
  pointer-events: none;
  touch-action: none;
  cursor: default;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
</style>
